import React from 'react'

import { GeoPoint } from '../../helpers/gps'
import { useMap } from './useMap'

export function useMapPanning() {
  const mapModel = useMap()

  return React.useCallback(
    (gps: GeoPoint) => {
      mapModel.panTo(gps)
    },
    [mapModel],
  )
}
